import * as React from 'react';
import * as styles from './ProjectsLink.css';
import { IconPlan16, ArticleParagraph2, IconArrowUpRight16 } from '@cian/ui-kit';

export const ProjectsLink = () => {
  return (
    <a
      className={styles['link']}
      href="/country-builders-projects/?utm_medium=country-builders&utm_content=link"
      target="_blank"
    >
      <IconPlan16 color="primary_100" />
      <div className={styles['link-name']}>
        <ArticleParagraph2 color="primary_100" as="span">
          В каталог проектов
        </ArticleParagraph2>
      </div>
      <IconArrowUpRight16 color="primary_100" stroke="white" />
    </a>
  );
};
